import { defineComponent, h } from 'vue';
import { QCard, QIcon } from 'quasar';
import utils from '../../../Shared/utils.jsx';
import BaseComponent from './BaseComponentMixin.jsx';

export default defineComponent({
    name: 'dynamic-control-container-dsgn',
    mixins: [BaseComponent],
    components: { QCard, QIcon },
    data: function () {
        return {
        }
    },
    render(h) {
        let name;
        if (!this.name)
            name = this.type;
        else
            name = this.name + ':' + this.type || 'Unnamed';

        const style = {
            paddingRight: "4px",
            paddingBottom: "4px",
            ...utils.getSize(this.controlData ? this.controlData.SizeOptions : null, this.parentType, this.$parent)
        };
//                    <div class={{ "designer-container-hovering": true, 'designer-container-selected': this.selected$ }}></div>

        return (
            <div
                class={{ 'designer-container': true, selected: this.selected$ }}
                style={style}
                onClick={(e) => this.handleClick(e)}>

                <QCard class="q-mx-auto q-pa-xs" flat bordered style="display: flex; flex-direction: column; flex-grow: 1;">
                    <div class={{ "designer-container-hovering": true, 'designer-container-selected': this.selected$ }}></div>
                    {name}<br />
                    <QIcon name="mdi-puzzle-edit" />
                </QCard>
            </div>
        );
    }
});